/**
 * App Config File
 */

export default {
    appURL: process.env.NODE_ENV === 'development' ? 'http://aiu.edu.eg/portal' : 'https://aiu.edu.eg/portal',
    API_URL: process.env.NODE_ENV === 'development' ? 'https://dev.lykss.com:8081/V1' : 'https://dev.lykss.com:8081/V1',
    controlPanelPath: '',
    locales: { en: { title: 'English', flag: 'en', short: 'en' }, ar: { title: 'العربية', flag: 'ar', short: 'ar' } },
    fallback_locale: 'en',
    imgPath: 'https://aiu.edu.eg/portal', 
    itemsPerPage: 999, 
    
  
    brandHeader: 'AIU',
    // Temp
    LoginURL: '/session/login', 
    appLogo: 'logo.png', // App Logo, 
    darkAppLogo: 'logo.png', // App Logo,
    darkLogo: 'static/site-dark-logo.png', // dark logo
    brand: 'AlAlamein International University ', // Brand Name 
    copyrightText: 'AlAlamein International University © 2021 All Rights Reserved.', // Copyright Text
    enableUserTour: false, // Enable User Tour 
    weatherApiId: 'b1b15e88fa797225412429c1c50c122a1', // weather API Id
    weatherApiKey: '69b72ed255ce5efad910bd946685883a' // weather APi key
}
